module.exports = __webpack_public_path__ + "static/media/ginecologica.ff183256.svg";